<template>
  <div>
    <hero></hero>
    <request-experiment></request-experiment>
     <l-footer></l-footer>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>